/**
 * 자료 뷰어 주소 한 곳. 목록(S3·NAS)과 뷰어가 <b>같은 규칙</b>으로 주소를 만들고 읽게 한다.
 *
 * <p>뷰어는 <b>같은 창</b>에서 연다 — 껍데기(상단바·사이드바)는 {@code AppLayout} 이 이 경로에서
 * 걷어 내므로 화면을 끝까지 쓴다. 닫으면 뒤로 가기라 보고 있던 폴더가 그대로 살아 있다.
 * (엑셀·워드·PPT 는 반대로 <b>새 창</b>이다 — 몇 시간 열어 두는 편집 창이라 목록을 오가는 동안
 * 닫히면 안 된다. {@code openOfficeWindow} 참고.)
 */
export function docsViewerHref(
  source: 'S3' | 'NAS',
  ref: string,
  connectionId?: string | null,
  /**
   * 읽기 전용으로 연다 — 계약서처럼 <b>원본에 손대면 안 되는</b> 서류(사용자 지시 2026-08-28).
   * 「수정하기」·「주석 넣어 내려받기」만 사라지고 보는 일은 전부 그대로다(글자 검색·확대·페이지 이동).
   *
   * <p><b>표시일 뿐 인가가 아니다.</b> 주소에 붙는 값이라 지우면 버튼이 돌아오지만, 그때도 서버가
   * 거부한다({@code DocAnnotationService.requireCanWrite}). 여기서 감추는 이유는 눌러 봐야 막히는
   * 버튼을 남기지 않기 위해서다.
   */
  readOnly = false,
): string {
  const params = new URLSearchParams({ source, ref });
  if (connectionId) params.set('connectionId', connectionId);
  if (readOnly) params.set('readonly', '1');
  return `/docs/view?${params.toString()}`;
}
